import React from 'react'
import { SmallTickIcon, Pane, Text } from 'evergreen-ui'

const StatusRegister_4 = ({ DataRegister }) => {
  return (
    <>
      <Pane
        color="#ffffff"
        backgroundColor="#164e00"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={0}
        display="flex" alignItems="center" justifyContent="center"
      >
        <Text color="#ffffff" fontWeight={700}>
          <SmallTickIcon /> ผลการคัดเลือก
        </Text>
      </Pane>
      <Pane
        color="#1b4332"
        backgroundColor="#d8f3dc"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={0}
        marginTop={8}
      >
        &nbsp;
        {/* {
          DataRegister[0].Major1_MAJOR_ID === "9902" ?
            (
              <Text color="#1b4332" fontWeight={700}>
                ผู้ผ่านการคัดเลือก {DataRegister[0].QUOTA_NAME}{" "}
                {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
              </Text>

            ) : (
              <Text color="#1b4332" fontWeight={700}>
                ผู้มีสิทธิ์เข้าศึกษา {DataRegister[0].QUOTA_NAME}{" "}
                {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
              </Text>
            )
        } */}
        <Text color="#1b4332" fontWeight={700}>
          ผู้มีสิทธิ์เข้าศึกษา {DataRegister[0].QUOTA_NAME}{" "}
          {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
        </Text>

        <br />
        <Text color="#1b4332" fontWeight={700}>
          {DataRegister[0].Major1_faculty_name}{" "}
          {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
        </Text>
        <br />
        <Text color="#1b4332" fontWeight={700}>
          {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
        </Text>
      </Pane>
      <Pane
        hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null ||
          DataRegister[0].REGISTER_ORDER?.includes(DataRegister[0].Major1_MAJOR_ID)}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        marginTop={8}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
      </Pane>
      <Pane
        hidden={DataRegister[0].REGISTER_ORDER_NUMBER1 === null ||
          DataRegister[0].REGISTER_ORDER1?.includes(DataRegister[0].Major1_MAJOR_ID)}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        marginTop={8}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER1}
      </Pane >

      {
        DataRegister[0].Major1_MAJOR_ID === "9902" ? (
          // <>
          //   <Pane
          //     // hidden={AllowPayNurse()}
          //     backgroundColor={"#fffae5"}
          //     color="#c36f09"
          //     paddingY={4}
          //     paddingX={5}
          //     fontSize={14}
          //     fontFamily=""
          //     margin={0}
          //     marginTop={8}
          //     fontWeight={700}
          //   >
          //     ส่งผลการตรวจร่างกายฉบับจริง ตั้งแต่วันนี้ ถึงวันที่ 15 ธันวาคม 2568 ณ
          //     อาคารคณะพยาบาลศาสตร์ มหาวิทยาลัยราชภัฏกำแพงเพชร
          //   </Pane>
          //   <Text color="red">หมายเหตุ* </Text>
          //   <Text color="red">ประกาศรายชื่อผู้มีสิทธิ์เข้าศึกษา ภาคปกติ คณะพยาบาลศาสตร์ วันที่ 19 ธันวาคม 2568</Text>
          // </>
          <Pane display="flex" flexDirection="column" marginTop={8}>
            <Text color="red">หมายเหตุ*</Text>
            <Text fontSize={"12px"}>
              1. ผู้มีสิทธิ์เข้าศึกษา สามารถยืนยันสิทธิ์ และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 19 ธันวาคม 2568 - 26 ธันวาคม 2568 หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
            </Text>
          </Pane>

        ) : (
          <Pane display="flex" flexDirection="column" marginTop={8}>
            <Text color="red">หมายเหตุ*</Text>
            {
               DataRegister[0].Major1_MAJOR_ID === "8301" || DataRegister[0].Major1_MAJOR_ID === "8203" || DataRegister[0].Major1_MAJOR_ID === "8201" || DataRegister[0].Major1_MAJOR_ID === "8205" || DataRegister[0].Major1_MAJOR_ID === "8401"
                ? (
                <>
                <Text fontSize={"12px"}>
              1. ผู้มีสิทธิ์เข้าศึกษา สามารถยืนยันสิทธิ์ และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 20 กุมภาพันธ์ - 1 มีนาคม 2569 หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
            </Text>
                </>
              ) : (
              <>
                <Text fontSize={"12px"}>
              1. ผู้มีสิทธิ์เข้าศึกษา สามารถยืนยันสิทธิ์ และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 5 - 7 กุมภาพันธ์ 2569 หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
            </Text>
            {/* <Text fontSize={"12px"}>
              2. ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ จะประกาศผลการคัดเลือก เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง (ตัวสำรอง) ในวันที่ 5 กุมภาพันธ์ 2569
            </Text> */}
              </>
            )
            }
            
          </Pane>
        )
      }

    </>


  )
}

export default StatusRegister_4